module.exports = __webpack_public_path__ + "static/img/The Chariot.ed6a9c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/The Chariot.jpg
// module id = 1308
// module chunks = 0